import { render } from "./DropZone.vue?vue&type=template&id=69620c38&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"

import "./DropZone.vue?vue&type=style&index=0&id=69620c38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69620c38"]])

export default __exports__